import { render, staticRenderFns } from "./yxzl.vue?vue&type=template&id=230739f4&scoped=true&"
import script from "./yxzl.vue?vue&type=script&lang=js&"
export * from "./yxzl.vue?vue&type=script&lang=js&"
import style0 from "./yxzl.vue?vue&type=style&index=0&id=230739f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230739f4",
  null
  
)

export default component.exports